import "./App.css";
import ListItem from "./common/list.tsx";

function App() {
  return (
    <div className='App'>
      <ListItem />
    </div>
  );
}

export default App;
